import html2canvas from "html2canvas";
import nidi_html2canvas from "@nidi/html2canvas";

export const captureSlidePreview = (slideId, textArea = false) => {
	let div = document.getElementById(slideId);
	if (textArea) {
		return new Promise((resolve, reject) => {
			nidi_html2canvas(div, {
				letterRendering: 1,
				allowTaint: true,
				useCORS: true,
			})
				.then(function (canvas) {
					resolve(canvas.toDataURL("image/webp", 0.1));
				})
				.catch((e) => {
					resolve(false);
				});
		});
	} else {
		return new Promise((resolve, reject) => {
			html2canvas(div, {
				letterRendering: 1,
				allowTaint: true,
				useCORS: true,
			})
				.then(function (canvas) {
					resolve(canvas.toDataURL("image/webp", 0.1));
				})
				.catch((e) => {
					resolve(false);
				});
		});
	}
};
